module.exports = __webpack_public_path__ + "img/placeholder-venue.646d6fdc.svg";